import * as user from './user'
import * as chat from './chat'
import * as broadcasts from './broadcasts'
import * as networks from './networks'
import * as users from './users'
import * as staff from './staff'
import * as search from './search'
import * as deepgram from './deepgram'
import * as map from './map'
import * as reclips from './reclips'
import * as shares from './shares'
import * as autoTrim from './autoTrim'
import * as openai from './openai'
import * as schools from './schools'
import * as reactions from './reactions'
import * as teamReclipStory from './teamReclipStory'
import * as shareVideos from './shareVideos'
import * as suggestions from './suggestions'
import * as onboarding from './onboarding'
import * as harsh from './harsh'
import * as freePhoneNumbers from './freePhoneNumbers'
import * as chatbots from './chatbots'
import * as animatedVideos from './animatedVideos'
import * as animationTest from './animationTest'
import * as slack from './slack'
import * as recordingMetrics from './recordingMetrics'
import * as streamMetrics from './streamMetrics'
import * as streamControls from './streamControls'
import * as reports from './reports'

const api = {
  user,
  chat,
  broadcasts,
  networks,
  users,
  staff,
  search,
  deepgram,
  map,
  reclips,
  shares,
  openai,
  autoTrim,
  schools,
  reactions,
  teamReclipStory,
  shareVideos,
  suggestions,
  onboarding,
  harsh,
  freePhoneNumbers,
  chatbots,
  animatedVideos,
  animationTest,
  slack,
  recordingMetrics,
  streamMetrics,
  streamControls,
  reports,
}

export default api
